import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface VehiculoInvolucrado {
  id?: number; // opcional en creación
  placa: string;
  numero_interno: string;
  tipo_vehiculo: number;
  fecha_vencimiento: string;
  revision_tecnomecanica: string;
  propiedad_vehiculo: number;
  carga: number;
  descripcion_carga: string;
  empresa_transportadora: string;
  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class VehiculoInvolucradoService {
  private apiUrl = `${environment.apiUrl}/api/vehiculo-involucrado`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getVehiculos(): Observable<VehiculoInvolucrado[]> {
    return this.http
      .get<VehiculoInvolucrado[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener activos
  getVehiculosActivos(): Observable<VehiculoInvolucrado[]> {
    return this.http
      .get<VehiculoInvolucrado[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getVehiculoById(id: string | number): Observable<VehiculoInvolucrado> {
    return this.http
      .get<VehiculoInvolucrado>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getBySiniestroId(idSiniestro: string | number): Observable<VehiculoInvolucrado[]> {
    return this.http
      .get<VehiculoInvolucrado[]>(`${environment.apiUrl}/api/siniestro/${idSiniestro}/vehiculo-involucrado`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
createVehiculos(payload: VehiculoInvolucrado[]): Observable<VehiculoInvolucrado[]> {

  return this.http
    .post<VehiculoInvolucrado[]>(
      this.apiUrl,
      payload,
      { withCredentials: true }
    )
    .pipe(
      catchError((error) => throwError(() => error))
    );

}

  // Actualizar
  updateVehiculo(id: string | number, payload: VehiculoInvolucrado): Observable<VehiculoInvolucrado> {
    return this.http
      .put<VehiculoInvolucrado>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteVehiculo(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
